import { useTranslation } from 'react-i18next';
import ReactFlagsSelect from 'react-flags-select';
import { cn } from './ui/utils';

const COUNTRY_TO_LANG = { BR: 'pt', US: 'en', ES: 'es' };
const LANG_TO_COUNTRY = { pt: 'BR', en: 'US', es: 'ES' };
const COUNTRIES = ['BR', 'US', 'ES'];
const LABELS = {
  BR: 'Português',
  US: 'English',
  ES: 'Español',
};

export function LanguageSwitcher({ className = '', onChange, compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'pt';
  const selected = LANG_TO_COUNTRY[current] || 'BR';

  const handleSelect = (code) => {
    const lng = COUNTRY_TO_LANG[code] || 'pt';
    i18n.changeLanguage(lng);
    onChange?.(lng);
  };

  return (
    <ReactFlagsSelect
      countries={COUNTRIES}
      customLabels={LABELS}
      selected={selected}
      onSelect={handleSelect}
      selectButtonClassName={cn(
        'lang-flag-trigger !rounded-md !border !border-slate-200 !bg-white !text-slate-700 hover:!bg-slate-50',
        compact && 'lang-flag-trigger--compact',
        className
      )}
      placeholder=""
    />
  );
}

export default LanguageSwitcher;
